import React from 'react';
import { createRoot, hydrateRoot } from "react-dom/client";
import './index.css';
import Router from './Router';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
if (container.hasChildNodes()) {
  hydrateRoot(container, <Router />);
} else {
  createRoot(container).render(<Router />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
